import { render } from "./CustomerManifestDashboard.vue?vue&type=template&id=11a424cc&scoped=true"
import script from "./CustomerManifestDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerManifestDashboard.vue?vue&type=script&lang=js"

import "./CustomerManifestDashboard.vue?vue&type=style&index=0&id=11a424cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a424cc"]])

export default __exports__